import React, { PureComponent } from 'react';
import TopbarSidebarButton from './TopbarSidebarButton';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { login, logout, getCurrentUser } from '../../../redux/Auth';
import LoginInfo from '../../../components/custom/LoginInfo';
import { isEmpty } from '../../../helpers/utils';
import { getCurrentReactUrlPath } from '../../../helpers/domutils';

class Topbar extends PureComponent {
  constructor(props) {
    super(props);

    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);
    this.mobileView = window.matchMedia("(max-width: 560px)");
    this.TopbarRight = this.TopbarRight.bind(this);

    this.state = {
      isMobile: false,
    }
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  componentDidMount() {
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    // const isMobileView = this.state.isMobile;
  }

  componentWillUnmount() {
    this.mobileView.removeListener(this.mediaqueryresponse);
  }

  TopbarRight() {
    const TopbarRight = (this.props.global || {}).TopbarRight || {};
    const callback = TopbarRight.callback;
    if (typeof (callback) === 'function' && TopbarRight.pathname && getCurrentReactUrlPath().match(new RegExp(TopbarRight.pathname + '$', 'i'))) {
      callback();
    }
  }

  render() {
    const isMobileView = this.state.isMobile;
    const TopbarLeft = (this.props.global || {}).TopbarLeft || {};
    const TopbarCenter = (this.props.global || {}).TopbarCenter || {};
    const TopbarRight = (this.props.global || {}).TopbarRight || {};
    const hasTopbarLeft = TopbarLeft.visibility;
    const hasTopbarCenter = TopbarCenter.pathname && getCurrentReactUrlPath().match(new RegExp(TopbarCenter.pathname + '$', 'i'));
    const hasTopbarRight = typeof (TopbarRight.callback) === 'function' && TopbarRight.pathname && getCurrentReactUrlPath().match(new RegExp(TopbarRight.pathname + '$', 'i'));
    console.log(this.props.global);
    return (
      <div className='topbar'>
        <div className={`${hasTopbarCenter ? 'topbar__wrapper-centered' : 'topbar__wrapper'}`}>
          <div className='topbar__left'>
            <TopbarSidebarButton />
            {hasTopbarLeft && <Link className='topbar__logo' to='/login'>
              <img src={require(`../../../img/${(isMobileView && hasTopbarCenter) ? 'logo_short' : 'logo'}.png`)} />
            </Link>}
          </div>
          {hasTopbarCenter &&
            <div className='topbar__center t-center m-auto truncate-99pc'>
              <span className='topbar__nav-link d-inline-block truncate-80pc'>
                <p className="fw-700 fs-16">{TopbarCenter.label || ''}</p>
              </span>
            </div>
          }
          <div className='topbar__right'>
            {hasTopbarRight &&
              <div>
                <div>
                  <a className='topbar__nav-link color-rg-black pt-12 pointer d-inline-block' onClick={this.TopbarRight}>
                    {!isEmpty(TopbarRight.icon) && <i className={`mdi mdi-${TopbarRight.icon} fs-24 lh-23 color-green`}></i>}
                  </a>
                </div>
              </div>
            }
            {this.props.global.topbarMenu &&
              <LoginInfo {...this.props} />
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  auth: state.auth,
  menu: (state.auth || {}).menu,
  global: state.global,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { login: login },
    { logout: logout },
    { getCurrentUser: getCurrentUser },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);


// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/Topbar.js